module.exports = __webpack_public_path__ + "static/media/nigel-s.8fd6ee55.png";